import { createMutation } from "@steto-care/steto-query";

import { ObservationsRepository } from "@/io/repository/ObservationsRepository.ts";
import { CreateNurseNotice, DeleteNurseNotice } from "@/models/NurseNoticeModel.ts";
import { PractitionerQueries } from "@/queries/PractitionerQueries.ts";

import { AlertsQueries } from "./AlertsQueries";

export class ObservationsQueries {
  constructor(
    private readonly practitioners: PractitionerQueries = new PractitionerQueries(),
    private readonly observations: ObservationsRepository = new ObservationsRepository(),
    private readonly alerts: AlertsQueries = new AlertsQueries(),
  ) {}

  /*******************************/
  /********** MUTATIONS **********/
  /*******************************/

  useCreateNotice = createMutation(
    "create-notice",
    async (data: CreateNurseNotice) => this.observations.createNotice(data),
    {
      onSuccess: (_, requestData, { client }) => {
        this.practitioners.useDoctorPatientList.invalidate(client, {});
        this.practitioners.useNursePatientList.invalidate(client, {});
        this.practitioners.useNurseNotice.invalidate(client, requestData.patient_id);
      },
    },
  );

  useDeleteNotice = createMutation(
    "delete-notice",
    async (data: DeleteNurseNotice) => this.observations.deleteNotice(data),
    {
      onSuccess: (_, requestData, { client }) => {
        this.practitioners.useDoctorPatientList.invalidate(client, {});
        this.practitioners.useNursePatientList.invalidate(client, {});
        this.practitioners.useNurseNotice.invalidate(client, requestData.patient_id);
      },
    },
  );

  useMitigateNotice = createMutation(
    "mitigate-notice",
    async (data: DeleteNurseNotice) => this.observations.mitigateNotice(data),
    {
      onSuccess: (_, requestData, { client }) => {
        this.practitioners.useDoctorPatientList.invalidate(client, {});
        this.practitioners.useNursePatientList.invalidate(client, {});
        this.practitioners.useNurseNotice.invalidate(client, requestData.patient_id);
        this.alerts.useListPatientAlerts.invalidate(client, requestData.patient_id);
      },
    },
  );
}
